<template>
  <!-- 数据统计，带图标的那种 -->
  <div class="data-count">
    <div v-for="(item, idx) in dataList" :key="idx" class="count-item" :style="{'--bg-color': `linear-gradient(to bottom, ${colorList[idx].start} , ${colorList[idx].end} )`}">
      <yq-icon :name="iconList[idx]"/>
      <div class="count-data">
        <div class="title"><slot name="title" :data="item">{{item.statisticName}}</slot></div>
        <div class="count"><slot name="count" :data="item">{{item.statisticCount}}</slot></div>
        <div class="type"><slot name="desc" :data="item">{{item.statisticType}}</slot></div>
      </div>
    </div>
  </div>
</template>

<script>


import YqIcon from "@/components/YqIcon.vue";

export default {
  props: {
    // 图标,图标必须大于或等于dataList的长度
    iconList: {
      type: Array,
      default: () => {
        return ["wodedingdan", "element-ui_sort"];
      }
    },
    // 数据
    dataList: {
      type: Array,
      default: function () {
        return [
          {
            statisticName: "用户数",
            statisticCount: "1000",
            statisticType: "同比增长 30%",
          },
          {
            statisticName: "销售单",
            statisticCount: "1000",
            statisticType: "对比上月 -2%",
          }
        ];
      }
    },
    // 颜色，颜色是以渐变色为一对，colorList必须大于或等于dataList的长度
    colorList: {
      type: Array,
      default: () => {return [{start: "#71cefb", end: "#4faff8"}, {start: "#fb8ec7", end: "#fa5da0"}]}
    }
  },
  name: "",
  components: {
    YqIcon
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.data-count{
  height: 100px;
  display: flex;
  justify-content: space-between;
  .count-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    :deep(.yq-icon){
      font-size: 30px;
      color: #FFF;
      border-radius: 50px;
      height: 50px;
      width: 50px;
      justify-content: center;
      line-height: 50px;
      background: var(--bg-color);
      margin-right: 10px;
    }
    .count-data{
      .title{
        color: var(--yq-font-color-desc);
      }
      .count{
        font-size: 22px;
        margin: 10px 0;
      }
      .type{
        color: var(--yq-font-color-desc);
        font-size: var(--yq-font-size-small);
      }
    }
  }
}
</style>